import { TextProps } from '@chakra-ui/react';
import MText from './MText';

export function BlankText(props: TextProps) {
  return (
    <MText fontStyle="italic" {...props}>
      Blank
    </MText>
  );
}
